import React, { useEffect, useState } from 'react'
import * as yup from 'yup'
import { GET_FREQUENCIES_ROUTES_OPTIONS } from '../../../../../../graphql/Catalog/Trucks/Routes/routesTrucks'
import { GET_ALL_WATER_STATIONS } from '../../../../../../graphql/Catalog/WaterStations/waterstations'
import {
  GET_ALL_TRUCKS,
  GET_CAPACITY_TRUCKS,
  GET_TRUCKS_AVAILABLE,
} from '../../../../../../graphql/Catalog/Trucks/trucks'
import { GET_USERS_BY_CHARGE } from '../../../../../../graphql/Catalog/Users/user'
import { GET_ALL_PROVIDERS } from '../../../../../../graphql/Catalog/Providers/providers'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useQuery } from '@apollo/client'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import InputController from '../../../../../Global/InputController'
import Box from '../../../../../Global/Box'

const StepRoute = ({
  isEdit,
  refWizard,
  data,
  setData,
  setIsValidSteps,
  submitEdit,
  routeCompleteOrOnRoute = false,
}) => {
  const [capacityTruck, setCapacityTruck] = useState(null)
  const [dataLabels, setDataLabels] = useState({
    plate_number: '',
    capacity: '',
  })
  const [options, setOptions] = useState({
    water_station_id: [],
    truck_id: [],
    user_id: [],
    capacity: [],
  })

  const validationSchema = yup.object().shape({
    id: yup.string(),
    route_id: yup.string(),
    water_station_id: submitEdit
      ? yup.string()
      : yup.string().required('Este campo es requerido'),
    // user_id: yup.string().required('Este campo es requerido'),
    volume: yup.string().required('Este campo es requerido'),
    truck_id: yup.string().required('Este campo es requerido'),
    // provider_id: yup.string().required('Este campo es requerido'),
    scheduled_date: yup.string().required('Este campo es requerido'),
    // frequency: yup.string().required('Este campo es requerido'),
  })

  const {
    control,
    methods,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  // const {
  //   loading: loadingFrequency,
  //   error: errorFrequency,
  //   data: dataFrequency,
  // } = useQuery(GET_FREQUENCIES_ROUTES_OPTIONS, {
  //   variables: {},
  //   fetchPolicy: 'cache-and-network',
  // })

  const {
    loading: loadingWaterStations,
    error: errorWaterStations,
    data: dataWaterStations,
  } = useQuery(GET_ALL_WATER_STATIONS, {
    variables: {},
    fetchPolicy: 'cache-and-network',
  })

  const {
    loading: loadingTrucks,
    error: errorTrucks,
    data: dataTrucks,
  } = useQuery(GET_TRUCKS_AVAILABLE, {
    variables: {
      capacity: capacityTruck ? capacityTruck : null,
    },
    fetchPolicy: 'cache-and-network',
    skip: !capacityTruck,
  })

  // const {
  //   loading: loadingUsers,
  //   error: errorUsers,
  //   data: dataUsers,
  // } = useQuery(GET_USERS_BY_CHARGE, {
  //   variables: {
  //     // edit: submitEdit ? true : false,
  //   },
  //   fetchPolicy: 'cache-and-network',
  // })

  const {
    loading: loadingCapacity,
    error: errorCapacity,
    data: dataCapacity,
  } = useQuery(GET_CAPACITY_TRUCKS, {
    variables: {},
    fetchPolicy: 'cache-and-network',
  })

  // const {
  //   loading: loadingProviders,
  //   error: errorProviders,
  //   data: dataProviders,
  // } = useQuery(GET_ALL_PROVIDERS, {
  //   variables: {},
  //   fetchPolicy: 'cache-and-network',
  // })

  // useEffect(() => {
  //   try {
  //     if (loadingFrequency) return
  //     if (errorFrequency) throw errorFrequency
  //     if (!dataFrequency) return
  //     const { getFrequencyRoutes } = dataFrequency
  //     setOptions((prev) => ({
  //       ...prev,
  //       frequency: getFrequencyRoutes,
  //     }))
  //   } catch (error) {
  //     return toastSweetAlert({
  //       mode: 'error',
  //       message: error.message,
  //     })
  //   }
  // }, [dataFrequency, errorFrequency, loadingFrequency])

  useEffect(() => {
    try {
      if (loadingWaterStations) return
      if (errorWaterStations) throw errorWaterStations
      if (!dataWaterStations) return

      const { getAllWaterStations } = dataWaterStations

      const optionsWaterStations = getAllWaterStations.rows.map(
        (waterStation) => {
          return {
            value: waterStation.id,
            label: waterStation.name,
          }
        }
      )

      setOptions((prev) => ({
        ...prev,
        water_station_id: optionsWaterStations,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataWaterStations, errorWaterStations, loadingWaterStations])

  useEffect(() => {
    try {
      if (loadingTrucks) return
      if (errorTrucks) throw errorTrucks
      if (!dataTrucks) return

      const { getTrucksAvailables } = dataTrucks

      const optionsTrucks = getTrucksAvailables.map((truck) => {
        return {
          value: truck.id,
          label: `${truck.TrucksToUsersDrivers.name} ${truck.TrucksToUsersDrivers.first_name} - 
            ${truck.plate_number} - 
            ${truck.capacity}m³`,
        }
      })

      setOptions((prev) => ({
        ...prev,
        truck_id: optionsTrucks,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataTrucks, errorTrucks, loadingTrucks])

  // useEffect(() => {
  //   try {
  //     if (loadingUsers) return
  //     if (errorUsers) throw errorUsers
  //     if (!dataUsers) return

  //     const { getUsersByCharge } = dataUsers

  //     const optionsUsers = getUsersByCharge.map((user) => {
  //       return {
  //         value: user.id,
  //         label: `${user.name} ${user.first_name}`,
  //       }
  //     })

  //     setOptions((prev) => ({
  //       ...prev,
  //       user_id: optionsUsers,
  //     }))
  //   } catch (error) {
  //     return toastSweetAlert({
  //       mode: 'error',
  //       message: error.message,
  //     })
  //   }
  // }, [dataUsers, errorUsers, loadingUsers])

  useEffect(() => {
    try {
      if (loadingCapacity) return
      if (errorCapacity) throw errorCapacity
      if (!dataCapacity) return

      const { getCapacityForTruck } = dataCapacity

      setOptions((prev) => ({
        ...prev,
        capacity: getCapacityForTruck,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataCapacity, errorCapacity, loadingCapacity])

  // useEffect(() => {
  //   try {
  //     if (loadingProviders) return
  //     if (errorProviders) throw errorProviders
  //     if (!dataProviders) return

  //     const { getAllProviders } = dataProviders

  //     const optionsProviders = getAllProviders.rows.map((provider) => {
  //       return {
  //         value: provider.id,
  //         label: provider.card_name,
  //       }
  //     })

  //     setOptions((prev) => ({
  //       ...prev,
  //       provider_id: optionsProviders,
  //     }))
  //   } catch (error) {
  //     return toastSweetAlert({
  //       mode: 'error',
  //       message: error.message,
  //     })
  //   }
  // }, [dataProviders, errorProviders, loadingProviders])

  useEffect(() => {
    if (data.dataStepRoute) {
      reset(data.dataStepRoute)
      setCapacityTruck(+data.dataStepRoute.volume)
      setDataLabels({
        plate_number: data.dataStepRoute.plate_number,
        capacity: data.dataStepRoute.volume + 'm³',
      })
    }
  }, [data])

  const onSubmit = async (data) => {
    setData((old) => ({ ...old, dataStepRoute: data }))
    setIsValidSteps((old) => ({ ...old, stepRoute: true }))
    refWizard.current.nextTab()
  }

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={
          submitEdit ? handleSubmit(submitEdit) : handleSubmit(onSubmit)
        }
      >
        <Box
          btnSubmit={
            routeCompleteOrOnRoute === 3 || !routeCompleteOrOnRoute
              ? true
              : false
          }
          btnSubmitText={submitEdit ? 'Actualizar' : 'Siguiente'}
          errors={errors}
          withCard={false}
          content={
            <>
              {submitEdit && (
                <div className="row p-3">
                  <div className="col-12 modal-status-box-header">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2">
                        <span className="title-details">Camión</span>
                        <br />
                        <span className="content-details">
                          {dataLabels?.plate_number}
                        </span>
                      </div>
                      <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2">
                        <span className="title-details">Capacidad</span>
                        <br />
                        <span className="content-details">
                          {dataLabels?.capacity}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="row p-3">
                {!submitEdit && (
                  <div className="pb-3 col-lg-6">
                    <InputController
                      control={control}
                      name="water_station_id"
                      label="Estación de agua"
                      inputType="choosen"
                      options={options.water_station_id}
                      menuPosition="fixed"
                      placeholderTxt="Selecciona una estación de agua"
                    />
                  </div>
                )}
                {/* <div className={'pb-3 col-lg-6'}>
                  <InputController
                    control={control}
                    name="user_id"
                    label="Chofer"
                    inputType="choosen"
                    options={options.user_id}
                    menuPosition="fixed"
                    placeholderTxt="Selecciona un chofer"
                    disabled={routeCompleteOrOnRoute}
                  />
                </div> */}
                <div className={'pb-3' + submitEdit ? 'col-lg-6' : 'col-lg-6'}>
                  <InputController
                    control={control}
                    name="scheduled_date"
                    label="Fecha programada"
                    type="date"
                    disabled={routeCompleteOrOnRoute}
                  />
                </div>
                {!isEdit && (
                  <>
                    <div
                      className={'pb-3' + submitEdit ? 'col-lg-6' : 'col-lg-6'}
                    >
                      <InputController
                        control={control}
                        name="volume"
                        label="Capacidad"
                        inputType="choosen"
                        options={options.capacity}
                        menuPosition="fixed"
                        placeholderTxt="Selecciona una capacidad"
                        changeAction={(e) => setCapacityTruck(e.value)}
                        disabled={routeCompleteOrOnRoute}
                      />
                    </div>
                  </>
                )}
                {(!isEdit || routeCompleteOrOnRoute === 3) && (
                  <div
                    className={'pb-3' + submitEdit ? 'col-lg-6' : 'col-lg-6'}
                  >
                    <InputController
                      control={control}
                      name="truck_id"
                      label="Camión"
                      inputType="choosen"
                      options={options.truck_id}
                      menuPosition="fixed"
                      placeholderTxt="Selecciona un camión"
                      // disabled={routeCompleteOrOnRoute}
                    />
                  </div>
                )}
              </div>
              {/* <div className="col-lg-6">
                  <InputController
                    control={control}
                    name="provider_id"
                    label="Proveedor"
                    inputType="choosen"
                    options={options.provider_id}
                    menuPosition="fixed"
                    placeholderTxt="Selecciona un proveedor"
                  />
                </div> */}
              {/* <div className="col-lg-6">
                  <InputController
                    control={control}
                    name="frequency"
                    label="Frecuencia"
                    inputType="choosen"
                    options={options.frequency}
                    menuPosition="fixed"
                    placeholderTxt="Selecciona una frecuencia"
                  />
                </div> */}
            </>
          }
        />
      </form>
    </FormProvider>
  )
}

export default StepRoute
